import { Logger } from 'aws-amplify';
import { getUserCurrentlyAuthenticated } from './authentication';

const logger = new Logger('WatchExchanger');

// Override the default logging function
logger.log = async (level, userID, ...args) => {
  const logData = {
    logStreamName: 'watchExchangerLogStream',
    logEvents: [
      {
        timestamp: new Date().getTime(),
        message: `[${level}] [${userID}] ${args.map(arg => JSON.stringify(arg)).join(" ")}`,
      },
    ],
  };

  const response = await fetch('https://32uqkg4b2frkatj7i5tz5vck440xesmq.lambda-url.us-east-1.on.aws/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(logData),
  });

  if (!response.ok) {
    console.error('Error sending log data: ', response?.body);
  }
};

// Create logger.error and logger.info methods
logger.error = (...args) => {
  let userID;
  getUserCurrentlyAuthenticated()
    .then((user) => userID = user.attributes.email)
    .catch(() => {})
    .finally(() => logger.log('ERROR', userID, ...args));
};

logger.info = (...args) => {
  let userID
  getUserCurrentlyAuthenticated()
    .then((user) => userID = user.attributes.email)
    .catch(() => {})
    .finally(() => logger.log('INFO', userID, ...args));
};

export default logger;
